import React from 'react'
import AcceptedCardListContainer from '../AcceptedCardListContainer.jsx'
import { useSelector } from 'react-redux'

function AcceptedList({ title }) {
    const { user } = useSelector((state) => state.user);

    return (
        <AcceptedCardListContainer user={user} matches={user.acceptedInvites} title={title} />
    )
}

export default AcceptedList